import { ToastContainer } from "react-toastify";

const ToastManager = ({
  
}) => {

  return (
    <>
      <ToastContainer 
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3} 
      />
    </>
  );
};

export default ToastManager;